import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export type CompraterRoutingDestination = 'NWX' | 'PC' | null;

export type CompraterRoutingResponse = {
  comparativeQuoteId: string;
  destination: CompraterRoutingDestination;
}[];

@Injectable({
  providedIn: 'root',
})
export class CompraterRoutingAdapter {
  constructor() {}

  fetchCompraterRouting(quoteId: string): Observable<CompraterRoutingResponse> {
    return of([{ comparativeQuoteId: quoteId, destination: 'NWX' }]);
  }
}
